export { IconsPhone } from "./IconsPhone";
